export const isPlayRequestPending = (playRequests, userId) =>
  playRequests?.find(r => r.userId === userId);

export const isPlayerConfirmed = (players, userId) =>
  players?.find(r => r.userId === userId);

export const isPlayerConfirmedOrPending = (shift, userId) =>
  isPlayRequestPending(shift.playRequests, userId) ||
  (shift.isReserved && isPlayerConfirmed(shift.players, userId));

const getTotalGoals = (stats, local) => {
  let goals = 0;
  stats
    .filter(({ isLocal }) => isLocal === local)
    .forEach(p => {
      goals += p.goals;
    });
  return goals;
};

export const getScore = (stats, localName, visitName) =>
  `${localName} ${getTotalGoals(stats, true)} - ${getTotalGoals(
    stats,
    false,
  )} ${visitName}`;
